import { PostGridPaginator } from "../models/PostGridPaginator.js";

/**
 * Page controller for /discussions.
 * Pagination comes from PostGridPaginator.
 * Exported for the node --test unit suite; esbuild's IIFE bundle output drops the export.
 */
export class DiscussionsPage extends PostGridPaginator {

    constructor() {
        super("/discussions/paginate");

        // Set up Intersection Observer to watch for visible placeholders
        this.setupIntersectionObserver();
    }

}

document.addEventListener("DOMContentLoaded", async function() {
    new DiscussionsPage();
});
